export const GFUNC_DOMAIN="https://europe-west1-claudittest.cloudfunctions.net/api"
//export const GFUNC_DOMAIN="http://192.168.1.100:5001/claudittest/europe-west1/api"
//export const GFUNC_DOMAIN="http://192.168.1.101:5000/claudittest/europe-west1/api"
//export const GFUNC_DOMAIN="/api"